import { http } from '@/utils/http.js';
import { orgPath } from '@/utils/paths.js';

export const MemberEmailAddressesApi = {
  index(id) {
    return http.get(`${orgPath()}/travelers/${id}/email-addresses`).then((response) => response.data);
  },

  store(id, data) {
    return http.post(`${orgPath()}/travelers/${id}/email-addresses`, data).then((response) => response.data.data);
  },

  destroy(id, emailId) {
    return http
      .delete(`${orgPath()}/travelers/${id}/email-addresses/${emailId}`)
      .then((response) => response.data.data);
  },
};
